const tipoOperacion = [
  { label: "Residente", value: "RESIDENTE" },
  { label: "No Residente", value: "NO_RESIDENTE" },
];

export default tipoOperacion;
